import axios from 'axios';
import { API_BASE_URL } from '../config/env';

export const API_URL = API_BASE_URL;

export const axiosApi = axios.create({
  baseURL: API_BASE_URL,
});

axiosApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function get(url, config = {}) {
  return axiosApi.get(url, { ...config }).then(response => {
    return response.data;
  });
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function postFormData(url, data, config = {}) {
  return axiosApi.post(url, data, { ...config }).then(response => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function putFormData(url, data, config = {}) {
  return axiosApi.put(url, data, { ...config }).then(response => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then(response => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data);
}

export async function download(url, config = {}) {
  return axiosApi.get(url, { ...config, responseType: 'blob' });
}
